module.exports = __webpack_public_path__ + "static/media/order-failure-icon.a7eee2ef.svg";